import { settingsConstants as sc } from 'srcReact/Settings/constant'
import { settingsService as ss, profileService, settingsService } from 'srcReact/services'
import { commonActions } from 'srcReact/components'

export const settingsActions = {
  setInitial,
  setCredValue,
  setUpdateFormActive,
  setVerificationFormActive,
  setOrgDocsActive,
  setIntegrationActive,
  getUserDetails,
  putNames,
  putEmail,
  setEmailActivationCode,
  setEmailCodeValidation,
  setUpdatedEmail,
  putPassword,
  putNumber,
  setPasswordResetKey,
  setNotificationFormActive,
  setCodeError,
  setSuccess,
  setCountryCode,
  setResetSuccess,
  toggleAllSettings,
  toggleAllGroupSettings,
  getGroupList,
  getDefaultNotificationSettings,
  getNotificationSettings,
  setGroupFormActive,
  setGroupDetails,
  updateNotificationSettings,
  updateLanguage,
  deactivateAccount,
  requestDeleteAccount,
  clearDeactivatedData,
  putUserInfo
}

function setInitial() {
  return {
    type: sc.INITIAL_STATE
  }
}

//Account
function setCredValue(value) {
  return {
    type: sc.CRED_VALUE,
    value
  }
}

function setSuccess(value) {
  return {
    type: sc.SET_SUCCESS,
    value
  }
}

function setResetSuccess(value) {
  return {
    type: sc.SET_PASSWORD_RESET_SUCCESS,
    value
  }
}

function setCodeError(value) {
  return {
    type: sc.SET_CODE_ERROR,
    value
  }
}

function setUpdateFormActive(value) {
  return {
    type: sc.UPDATE_FORM_TOGGLE_STATUS,
    value
  }
}

function setUpdatedEmail(value) {
  return {
    type: sc.SET_UPDATED_EMAIL,
    value
  }
}

function setCountryCode(value) {
  return {
    type: sc.SET_COUNTRY_CODE,
    value
  }
}

function setVerificationFormActive(value) {
  return {
    type: sc.SET_VERFICATION_FORM_STATUS,
    value
  }
}

function setOrgDocsActive(value) {
  return {
    type: sc.SET_ORG_DOCS_STATUS,
    value
  }
}

function setIntegrationActive(value) {
  return {
    type: sc.SET_INTEGRATION_STATUS,
    value
  }
}

function getUserDetails() {
  return (dispatch) => {
    dispatch(request())

    ss.getUserDetails().then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: sc.GET_USER_DETAILS }
  }
  function success(response) {
    return { type: sc.GET_USER_DETAILS_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.GET_USER_DETAILS_FAILURE, error }
  }
}

function putNames(payload) {
  return (dispatch) => {
    dispatch(request())

    ss.putNames(payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: sc.PUT_NAMES_REQUEST }
  }
  function success(response) {
    return { type: sc.PUT_NAMES_SUCCESS, response, payload }
  }
  function failure(error) {
    return { type: sc.PUT_NAMES_FAILURE, error }
  }
}

function putEmail(payload) {
  return (dispatch) => {
    dispatch(request())

    ss.putEmail(payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: sc.PUT_EMAIL }
  }
  function success(response) {
    return { type: sc.PUT_EMAIL_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.PUT_EMAIL_FAILURE, error }
  }
}

function setEmailActivationCode(payload) {
  return (dispatch) => {
    dispatch(request())

    ss.setEmailActivationCode(payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: sc.EMAIL_ACTIVATION_CODE_REQUEST }
  }
  function success(response) {
    return { type: sc.EMAIL_ACTIVATION_CODE_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.EMAIL_ACTIVATION_CODE_FAILURE, error }
  }
}

function setEmailCodeValidation(payload) {
  return (dispatch) => {
    dispatch(request())

    ss.setEmailCodeValidation(payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: sc.EMAIL_CODE_VALIDATION_REQUEST }
  }
  function success(response) {
    return { type: sc.EMAIL_CODE_VALIDATION_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.EMAIL_CODE_VALIDATION_FAILURE, error }
  }
}

function setPasswordResetKey() {
  return (dispatch) => {
    dispatch(request())

    ss.setPasswordResetKey().then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: sc.SET_PASSWORD_RESET_KEY_REQUEST }
  }
  function success(response) {
    return { type: sc.SET_PASSWORD_RESET_KEY_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.SET_PASSWORD_RESET_KEY_FAILURE, error }
  }
}

function putPassword(payload) {
  return (dispatch) => {
    dispatch(request())

    ss.putPassword(payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: sc.PUT_PASSWORD }
  }
  function success(response) {
    return { type: sc.PUT_PASSWORD_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.PUT_PASSWORD_FAILURE, error }
  }
}

function putNumber(payload) {
  return (dispatch) => {
    dispatch(request())

    ss.putNumber(payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: sc.PUT_NUMBER }
  }
  function success(response) {
    return { type: sc.PUT_NUMBER_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.PUT_NUMBER_FAILURE, error }
  }
}

//Notifications
function setNotificationFormActive(value) {
  return {
    type: sc.SET_NOTIFICATION_FORM_STATUS,
    value
  }
}

function toggleAllSettings(payload) {
  return (dispatch) => {
    dispatch(request())

    ss.toggleAllSettings(payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: sc.ENABLE_DISABLE_ALL_SETTINGS_REQUEST }
  }
  function success(response) {
    return { type: sc.ENABLE_DISABLE_ALL_SETTINGS_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.ENABLE_DISABLE_ALL_SETTINGS_FAILURE, error }
  }
}

function toggleAllGroupSettings(payload) {
  return (dispatch) => {
    dispatch(request())

    ss.toggleAllGroupSettings(payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: sc.ENABLE_DISABLE_ALL_GROUP_SETTINGS_REQUEST }
  }
  function success(response) {
    return { type: sc.ENABLE_DISABLE_ALL_GROUP_SETTINGS_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.ENABLE_DISABLE_ALL_GROUP_SETTINGS_FAILURE, error }
  }
}

function getDefaultNotificationSettings(payload) {
  return (dispatch) => {
    dispatch(request())

    ss.getDefaultNotificationSettings(payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: sc.GET_DEFAULT_NOTIFICATION_SETTINGS_REQUEST }
  }
  function success(response) {
    return { type: sc.GET_DEFAULT_NOTIFICATION_SETTINGS_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.GET_DEFAULT_NOTIFICATION_SETTINGS_FAILURE, error }
  }
}

function getNotificationSettings(payload) {
  return (dispatch) => {
    dispatch(request())

    ss.getNotificationSettings(payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: sc.GET_NOTIFICATION_SETTINGS_REQUEST }
  }
  function success(response) {
    return { type: sc.GET_NOTIFICATION_SETTINGS_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.GET_NOTIFICATION_SETTINGS_FAILURE, error }
  }
}

function getGroupList(payload) {
  return (dispatch) => {
    dispatch(request())

    ss.getGroupList(payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: sc.GET_GROUP_LIST_REQUEST }
  }
  function success(response) {
    return { type: sc.GET_GROUP_LIST_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.GET_GROUP_LIST_FAILURE, error }
  }
}

function setGroupDetails(id, name, role, picture) {
  return {
    type: sc.SET_GROUP_DETAILS,
    id,
    name,
    role,
    picture
  }
}

function setGroupFormActive(value) {
  return {
    type: sc.SET_GROUP_FORM_STATUS,
    value
  }
}

function updateNotificationSettings(view, payload) {
  return (dispatch) => {
    dispatch(request())

    ss.updateNotificationSettings(view, payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: sc.UPDATE_NOTIFICATION_SETTINGS_REQUEST }
  }
  function success(response) {
    return { type: sc.UPDATE_NOTIFICATION_SETTINGS_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.UPDATE_NOTIFICATION_SETTINGS_FAILURE, error }
  }
}

function updateLanguage(key, value) {
  return (dispatch) => {
    dispatch(request())

    profileService.putProfileDetails(key, value).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: sc.UPDATE_LANGUAGE_REQUEST }
  }
  function success(response) {
    return { type: sc.UPDATE_LANGUAGE_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.UPDATE_LANGUAGE_FAILURE, error }
  }
}

function deactivateAccount(orgId, groupTransferData) {
  return (dispatch) => {
    dispatch(request(orgId))

    settingsService.deactivateAccount(orgId, groupTransferData).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: sc.DEACTIVATE_ACCOUNT_REQUEST }
  }
  function success(response) {
    return { type: sc.DEACTIVATE_ACCOUNT_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.DEACTIVATE_ACCOUNT_FAILURE, error }
  }
}

function requestDeleteAccount(orgId) {
  return (dispatch) => {
    dispatch(request(orgId))

    settingsService.requestDeleteAccount(orgId).then(
      (response) => {
        dispatch(success(response, orgId))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(orgId) {
    return { type: sc.REQUEST_TO_DELETE_ACCOUNT_REQUEST, orgId }
  }
  function success(response, orgId) {
    return { type: sc.REQUEST_TO_DELETE_ACCOUNT_SUCCESS, response, orgId }
  }
  function failure(error) {
    return { type: sc.REQUEST_TO_DELETE_ACCOUNT_FAILURE, error }
  }
}

function clearDeactivatedData() {
  return { type: sc.CLEAR_DEACTIVATE_DATA }
}

function putUserInfo(key, value) {
  return (dispatch) => {
    dispatch(request(key, value))

    profileService.putProfileDetails(key, value).then(
      (response) => {
        dispatch(success(response, { key, value }))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: sc.PUT_USER_INFO_REQUEST, response }
  }
  function success(response, payload) {
    response.updated = payload
    return { type: sc.PUT_USER_INFO_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.PUT_USER_INFO_FAILURE, error }
  }
}
